export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const COMIC_FAVORITE = 'COMIC_FAVORITE';
export const COMICS_LIST = 'COMICS_LIST';
export const USER_LOGGED = 'USER_LOGGED';
export const GET_USER = 'GET_USER';